import {
	BigNum,
	BN,
	ContractTier,
	oraclePriceBands as getOraclePriceBands,
	PositionDirection,
} from '@drift-labs/sdk';
import { COMMON_UI_UTILS, MarketId, ORDER_COMMON_UTILS } from '@drift/common';
import { DriftClient } from '@drift-labs/sdk';
import {
	DEFAULT_LIMIT_AUCTION_DURATION,
	syncGetCurrentSettings,
} from 'src/environmentVariables/EnvironmentVariables';
import { TRADE_PREP_UTILS } from 'src/stores/DriftStore/actions/actionHelpers/tradePrep';
interface Params {
	driftClient: DriftClient;
	direction: PositionDirection;
	marketId: MarketId;
	inputPrice: BigNum;
	auctionStartPrice: BN;
	oraclePrice: BN;
}

/**
 * Performs some common upfront work for calling `COMMON_UI_UTILS.getLimitAuctionParams`,
 * calls it, and returns the result.
 */
export function buildLimitAuctionParams({
	driftClient,
	direction,
	marketId,
	inputPrice,
	auctionStartPrice,
	oraclePrice,
}: Params) {
	const settings = syncGetCurrentSettings();

	const perpMarketAccount = marketId.isPerp
		? driftClient.getPerpMarketAccount(marketId.marketIndex)
		: undefined;

	const oraclePriceBands = (() => {
		if (!perpMarketAccount || !marketId.isPerp) {
			return undefined;
		}

		const marketOracleData = driftClient.getOracleDataForPerpMarket(
			marketId.marketIndex
		);

		if (!marketOracleData?.price) {
			return undefined;
		}

		return getOraclePriceBands(perpMarketAccount, marketOracleData);
	})();

	const auctionDuration = marketId.isPerp
		? ORDER_COMMON_UTILS.getPerpAuctionDuration(
				inputPrice.val.sub(auctionStartPrice).abs(),
				oraclePrice.abs(),
				perpMarketAccount?.contractTier ?? ContractTier.B
			)
		: DEFAULT_LIMIT_AUCTION_DURATION;

	return COMMON_UI_UTILS.getLimitAuctionParams({
		direction,
		inputPrice,
		startPriceFromSettings: auctionStartPrice, // Use the passed-in auctionStartPrice directly
		duration: auctionDuration,
		auctionStartPriceOffset:
			TRADE_PREP_UTILS.getMarketBasedAuctionStartPriceOffset(
				settings?.auctionStartPriceOffset as number | 'marketBased',
				marketId
			),
		oraclePriceBands,
	});
}
